export default __webpack_public_path__ + "static/media/user-input-menu.a939ee5a.svg";